module.exports = __webpack_public_path__ + "f52240f7876c78107ab7d110251698cf.jpg";